// 权限点
import Vue from 'vue'
import store from '@/store'
Vue.directive('has', {
  /** 权限指令**/
  // 当被绑定的元素插入到 DOM 中时……
  inserted: (el, binding, vnode) => {
    const value = binding.value
    const {rolePermission} = store.state.indexStore.accountInfo

    if (!(rolePermission || []).includes(value)) {
      // 权限点
      el.parentNode.removeChild(el)
    }
  }
})



// WEBPACK FOOTER //
// ./src/utils/permission.js